// Conoce el PREP
export { QueSonComputosComponent  } from './conoce-computos/que-son-computos/que-son-computos.component';
export { OperacionComputosComponent } from './conoce-computos/operacion-computos/operacion-computos.component';
export { NavegacionComputosComponent } from './conoce-computos/navegacion-computos/navegacion-computos.component';

// Elecciones Puebla
export { AcercaVotoComponent } from './elecciones-federales/acerca-voto/acerca-voto.component';
export { CargosElegiranComponent } from './elecciones-federales/cargos-elegiran/cargos-elegiran.component';
export { NormatividadComponent } from './elecciones-federales/normatividad/normatividad.component';
export { TipoCasillasComponent } from './elecciones-federales/tipo-casillas/tipo-casillas.component';
export { CircunscripcionesComponent } from './elecciones-federales/circunscripciones/circunscripciones.component';

// Actas
export { CatalogoObservacionesComponent } from './actas/catalogo-observaciones/catalogo-observaciones.component';
export { PorcentajeActasComponent } from './actas/porcentaje-actas/porcentaje-actas.component';

// Preguntas Frecuentes
export { PreguntasFrecuentesComponent } from './preguntas-frecuentes/preguntas-frecuentes.component';

// Otros
export { GlosarioComponent } from './glosario/glosario.component';
export { BuscadorComponent } from './shared/buscador/buscador.component';



// WEBPACK FOOTER //
// ./src/app/components/index.pagina.ts